// ============================================================
// The people at the table (v8.363.3): one entry per PERSON (uid), from the
// seats - a person may hold several seats over a night - with the name
// of the combatant they act as when that is known. Pure.
// ============================================================
import type { Person } from './types';

export interface SeatForPeople {
  uid?: string;
  displayName?: string;
  isGm?: boolean;
  online?: boolean;
}

export function peopleFrom(
  seats: readonly SeatForPeople[],
  actingBy: Record<string, string>,
  combatantName: (id: string) => string | null,
): Person[] {
  const byUid = new Map<string, Person>();
  for (const s of seats) {
    const uid = s.uid;
    if (!uid) continue;
    const had = byUid.get(uid);
    // An online seat's name wins over an offline one's.
    if (had && s.online === false) continue;
    byUid.set(uid, seatPerson(uid, s, had, actingNameOf(actingBy[uid], combatantName)));
  }
  return [...byUid.values()].sort((a, b) => a.name.localeCompare(b.name));
}

/** The name of whoever they act as, or null when they act as nobody. */
function actingNameOf(acting: string | undefined, combatantName: (id: string) => string | null): string | null {
  return acting ? combatantName(acting) : null;
}

/** One seat as a person, falling back to what an earlier seat of theirs said. */
function seatPerson(uid: string, s: SeatForPeople, had: Person | undefined, actingAsName: string | null): Person {
  return {
    uid,
    name: s.displayName || had?.name || uid,
    isGm: !!s.isGm || !!had?.isGm,
    actingAsName,
  };
}
